import messages from './exchange-graph-form-lang.json';
import { required } from 'vuelidate/lib/validators';
import { date } from '../../../common/js/validators';
import moment from 'moment';
import { BACKEND_DATE_FORMAT } from '../../../common/js/constants/constants';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueDatepicker from '@ui-common/vue-datepicker';
import VueErrorMessage from '@ui-common/vue-error-message';
const MIN_DATE = '2004-02-20';

export default {
	props: {
		currencies: {
			required: true
		},
		active: {
			required: true
		},
		rateTypes: {
			required: true
		}
	},
	data() {
		return {
			version: null,
			range: '0',
			model: {
				from: null,
				to: null,
				type: null,
				currency: null
			},
			types: []
		};
	},
	components: {
		VueDatepicker,
		VueSelect,
		VueSelectOption,
		VueErrorMessage
	},
	watch: {
		rateTypes(val) {
			this.types = [];
			if (val && val.rateTypesAvailable) {
				if (val.rateTypesAvailable.middleRate) {
					this.types.push({ id: 'middleRate', name: this.$t('middleRate') });
				}
				if (val.rateTypesAvailable.currency.buying) {
					this.types.push({ id: 'currencyBuyingRate', name: this.$t('currencyBuyingRate') });
				}
				if (val.rateTypesAvailable.currency.selling) {
					this.types.push({ id: 'currencySellingRate', name: this.$t('currencySellingRate') });
				}
				if (val.rateTypesAvailable.cheque.buying) {
					this.types.push({ id: 'chequeBuyingRate', name: this.$t('chequeBuyingRate') });
				}
				if (val.rateTypesAvailable.cheque.selling) {
					this.types.push({ id: 'chequeSellingRate', name: this.$t('chequeSellingRate') });
				}
				if (val.rateTypesAvailable.foreignExchange.buying) {
					this.types.push({ id: 'foreignExchangeBuyingRate', name: this.$t('foreignExchangeBuyingRate') });
				}
				if (val.rateTypesAvailable.foreignExchange.selling) {
					this.types.push({ id: 'foreignExchangeSellingRate', name: this.$t('foreignExchangeSellingRate') });
				}
			}
		},
		currencies: {
			handler(val) {
				if (val && val.currencies && val.currencies.length) {
					this.model.currency = val.defaults.to;
				}
			},
			immediate: true
		},
		range(minusMonth) {
			if (minusMonth) {
				this.model.to = moment().format(BACKEND_DATE_FORMAT);
				this.model.from = moment().subtract(minusMonth, 'months').format(BACKEND_DATE_FORMAT);
				this.updateForm();
			}
		},
		'model.from'() {
			if (this.model.from) {
				this.$emit('on-change-from', this.model.from);
				this.$emit('on-change-currency', this.model);
			}
		},
		'model.to'() {
			if (this.model.to) {
				this.$emit('on-change-to', this.model.to);
				this.$emit('on-change-currency', this.model);
			}
		},
		'model.currency'() {
			if (this.model.currency) {
				this.$emit('on-change-currency', this.model);
				this.updateForm();
			}
		}
	},
	validations() {
		return {
			model: {
				from: {
					required,
					date: date(BACKEND_DATE_FORMAT)
				},
				to: {
					required,
					date: date(BACKEND_DATE_FORMAT)
				},
				currency: {
					required
				}
			}
		};
	},
	i18n: { messages },
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		today() {
			return moment().format(BACKEND_DATE_FORMAT);
		},
		yesterday() {
			return moment().subtract(1, 'day').format(BACKEND_DATE_FORMAT);
		},
		minDate() {
			return moment(MIN_DATE).format(BACKEND_DATE_FORMAT);
		}
	},
	methods: {
		updateForm() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.$emit('on-update-form', this.model);
			}
		},
		typeChanged() {
			this.$emit('on-change-type', this.model.type);
		}
	},
	created() {
		let toDate = moment();
		this.model.to = toDate.format(BACKEND_DATE_FORMAT);
		this.model.from = toDate.format(BACKEND_DATE_FORMAT);
	}
};
